import { REPORT_TYPES, GRAPH_DATATYPE, QUALITATIVE_REPORT_LEVELS } from "../../../constants/app-constant";
import { getRandomUniqueColor, getLineGraphFormat } from "./format-utils";
import {
    VERTICALS,
    GRAPH_TYPES,
    CONSTANTS,
    useDynamicEntityColors,
} from "../../../constants/app-constant";
import { publicationPrintGenreFilterList } from "../../NewsAndAnalysis/NewAnalysis/AnalysisGroup/filter-constant";

const { V_ONLINE, V_PRINT } = VERTICALS;
const { PIE, TABLE, BAR_STACKED_EQUAL_HEIGHT, LINE, BAR_VERTICAL } = GRAPH_TYPES;
const {
    REPORTS: { TYPES },
} = CONSTANTS;

const {
    ENTITY,
    KEYWORD,
    JOURNALIST,
    CITY,
    PUBLICATION,
} = QUALITATIVE_REPORT_LEVELS;

const {
    ThematicEntityTrendCCM,
    ThematicEntityTrendIndex,
    ThematicEntityTrendNOA,
    ThematicEntityTrendReach,
    ThematicEntityTrendMAV,
    ThematicEntityTrendWordCount,
    ThematicEntityTonalityCCM,
    ThematicEntityTonalityIndex,
    ThematicEntityTonalityNOA,
    ThematicEntityTonalityMAV,
    ThematicEntityTonalityWordCount,
    ThematicEntityTonalityReach,
    ThematicJournalistTrendCCM,
    ThematicJournalistTrendIndex,
    ThematicJournalistTrendNOA,
    ThematicJournalistTrendReach,
    ThematicJournalistTrendMAV,
    ThematicJournalistTrendWordCount,
    ThematicJournalistTonalityCCM,
    ThematicJournalistTonalityIndex,
    ThematicJournalistTonalityNOA,
    ThematicJournalistTonalityMAV,
    ThematicJournalistTonalityWordCount,
    ThematicJournalistTonalityReach,
    ThematicKeywordTrendCCM,
    ThematicKeywordTrendIndex,
    ThematicKeywordTrendNOA,
    ThematicKeywordTrendReach,
    ThematicKeywordTrendMAV,
    ThematicKeywordTrendWordCount,
    ThematicKeywordTonalityCCM,
    ThematicKeywordTonalityIndex,
    ThematicKeywordTonalityNOA,
    ThematicKeywordTonalityMAV,
    ThematicKeywordTonalityWordCount,
    ThematicKeywordTonalityReach,
    ThematicPublicationTrendCCM,
    ThematicPublicationTrendIndex,
    ThematicPublicationTrendNOA,
    ThematicPublicationTrendReach,
    ThematicPublicationTrendMAV,
    ThematicPublicationTrendWordCount,
    ThematicPublicationTonalityCCM,
    ThematicPublicationTonalityIndex,
    ThematicPublicationTonalityNOA,
    ThematicPublicationTonalityMAV,
    ThematicPublicationTonalityWordCount,
    ThematicPublicationTonalityReach,
    ThematicCityTrendCCM,
    ThematicCityTrendIndex,
    ThematicCityTrendNOA,
    ThematicCityTrendReach,
    ThematicCityTrendMAV,
    ThematicCityTrendWordCount,
    ThematicCityTonalityCCM,
    ThematicCityTonalityIndex,
    ThematicCityTonalityNOA,
    ThematicCityTonalityMAV,
    ThematicCityTonalityWordCount,
    ThematicCityTonalityReach,
} = REPORT_TYPES;

const {
    ThematicEntitySOVOnline,
    ThematicEntitySOVPrint,
    ThematicEntityTrendOnline,
    ThematicEntityTrendPrint,
    ThematicEntityTonalityOnline,
    ThematicEntityTonalityPrint,
    ThematicJournalistSOVOnline,
    ThematicJournalistSOVPrint,
    ThematicJournalistTrendOnline,
    ThematicJournalistTrendPrint,
    ThematicJournalistTonalityOnline,
    ThematicJournalistTonalityPrint,
    ThematicKeywordSOVOnline,
    ThematicKeywordSOVPrint,
    ThematicKeywordTrendOnline,
    ThematicKeywordTrendPrint,
    ThematicKeywordTonalityOnline,
    ThematicKeywordTonalityPrint,
    ThematicPublicationSOVOnline,
    ThematicPublicationSOVPrint,
    ThematicPublicationTrendOnline,
    ThematicPublicationTrendPrint,
    ThematicPublicationTonalityOnline,
    ThematicPublicationTonalityPrint,
    ThematicCitySOVPrint,
    ThematicCityTrendPrint,
    ThematicCityTonalityPrint,
    ThematicNewEntitySOVOnline,
    ThematicNewEntitySOVPrint,
} = GRAPH_DATATYPE;

export const getThemesFromResponse = (d = []) => {
    const result = d;
    const themes = result && result[result.sequence[0]].returnData.themes;
    return themes;
}

export const newFormatThematicData = (
    d = [],
    report_type,
    graphDataType,
    selectedInlineGraphType,
    selectedInlineSentiment,
    selectedInlineEntity,
    selectedInlineDynamicFilter,
) => {
    const { online, print } = graphDataType;
    const isEntityLevel =
        online === ThematicEntitySOVOnline ||
        print === ThematicEntitySOVPrint ||
        online === ThematicEntityTrendOnline ||
        print === ThematicEntityTrendPrint ||
        online === ThematicEntityTonalityOnline ||
        print === ThematicEntityTonalityPrint;

    const isJournalistLevel =
        online === ThematicJournalistSOVOnline ||
        print === ThematicJournalistSOVPrint ||
        online === ThematicJournalistTrendOnline ||
        print === ThematicJournalistTrendPrint ||
        online === ThematicJournalistTonalityOnline ||
        print === ThematicJournalistTonalityPrint;

    const isKeywordLevel =
        online === ThematicKeywordSOVOnline ||
        print === ThematicKeywordSOVPrint ||
        online === ThematicKeywordTrendOnline ||
        print === ThematicKeywordTrendPrint ||
        online === ThematicKeywordTonalityOnline ||
        print === ThematicKeywordTonalityPrint;

    const isPublicationLevel =
        online === ThematicPublicationSOVOnline ||
        print === ThematicPublicationSOVPrint ||
        online === ThematicPublicationTrendOnline ||
        print === ThematicPublicationTrendPrint ||
        online === ThematicPublicationTonalityOnline ||
        print === ThematicPublicationTonalityPrint;

    const isCityLevel =
        print === ThematicCitySOVPrint ||
        print === ThematicCityTrendPrint ||
        print === ThematicCityTonalityPrint;

    const isNewLevel = online === ThematicNewEntitySOVOnline ||
        print === ThematicNewEntitySOVPrint;

    const level =
        (isEntityLevel) ? ENTITY :
            (isJournalistLevel) ? JOURNALIST :
                (isPublicationLevel) ? PUBLICATION :
                    (isCityLevel) ? CITY :
                        (isKeywordLevel) ? KEYWORD :
                            (isNewLevel) ? 'NewEntity' :
                                "No Level";

    const isTrend =
        report_type === ThematicEntityTrendCCM ||
        report_type === ThematicEntityTrendMAV ||
        report_type === ThematicEntityTrendNOA ||
        report_type === ThematicEntityTrendIndex ||
        report_type === ThematicEntityTrendWordCount ||
        report_type === ThematicEntityTrendReach ||
        report_type === ThematicJournalistTrendCCM ||
        report_type === ThematicJournalistTrendMAV ||
        report_type === ThematicJournalistTrendNOA ||
        report_type === ThematicJournalistTrendIndex ||
        report_type === ThematicJournalistTrendWordCount ||
        report_type === ThematicJournalistTrendReach ||
        report_type === ThematicPublicationTrendCCM ||
        report_type === ThematicPublicationTrendMAV ||
        report_type === ThematicPublicationTrendNOA ||
        report_type === ThematicPublicationTrendIndex ||
        report_type === ThematicPublicationTrendWordCount ||
        report_type === ThematicPublicationTrendReach ||
        report_type === ThematicCityTrendCCM ||
        report_type === ThematicCityTrendMAV ||
        report_type === ThematicCityTrendNOA ||
        report_type === ThematicCityTrendIndex ||
        report_type === ThematicCityTrendWordCount ||
        report_type === ThematicCityTrendReach ||
        report_type === ThematicKeywordTrendCCM ||
        report_type === ThematicKeywordTrendMAV ||
        report_type === ThematicKeywordTrendNOA ||
        report_type === ThematicKeywordTrendIndex ||
        report_type === ThematicKeywordTrendWordCount ||
        report_type === ThematicKeywordTrendReach;

    const isTonality =
        report_type === ThematicEntityTonalityCCM ||
        report_type === ThematicEntityTonalityMAV ||
        report_type === ThematicEntityTonalityNOA ||
        report_type === ThematicEntityTonalityIndex ||
        report_type === ThematicEntityTonalityWordCount ||
        report_type === ThematicEntityTonalityReach ||
        report_type === ThematicJournalistTonalityCCM ||
        report_type === ThematicJournalistTonalityMAV ||
        report_type === ThematicJournalistTonalityNOA ||
        report_type === ThematicJournalistTonalityIndex ||
        report_type === ThematicJournalistTonalityWordCount ||
        report_type === ThematicJournalistTonalityReach ||
        report_type === ThematicPublicationTonalityCCM ||
        report_type === ThematicPublicationTonalityMAV ||
        report_type === ThematicPublicationTonalityNOA ||
        report_type === ThematicPublicationTonalityIndex ||
        report_type === ThematicPublicationTonalityWordCount ||
        report_type === ThematicPublicationTonalityReach ||
        report_type === ThematicCityTonalityCCM ||
        report_type === ThematicCityTonalityMAV ||
        report_type === ThematicCityTonalityNOA ||
        report_type === ThematicCityTonalityIndex ||
        report_type === ThematicCityTonalityWordCount ||
        report_type === ThematicCityTonalityReach ||
        report_type === ThematicKeywordTonalityCCM ||
        report_type === ThematicKeywordTonalityMAV ||
        report_type === ThematicKeywordTonalityNOA ||
        report_type === ThematicKeywordTonalityIndex ||
        report_type === ThematicKeywordTonalityWordCount ||
        report_type === ThematicKeywordTonalityReach;


    const currentMeasure = (report_type) => {
        const measures = {
            NOA: "article_count",
            CCM: "ccmtotal",
            MAV: "mavtotal",
            Index: "indextotal",
            WC: "wordcounttotal",
            Reach: "reachtotal",
        };
        const noaRegex = /noa/i;
        const ccmRegex = /ccm/i;
        const mavRegex = /mav/i;
        const indexRegex = /index/i;
        const wordCountRegex = /wordCount/i;
        const reachRegex = /reach/i;
        if (noaRegex.test(report_type)) {
            return measures.NOA;
        } else if (ccmRegex.test(report_type)) {
            return measures.CCM;
        } else if (mavRegex.test(report_type)) {
            return measures.MAV;
        } else if (indexRegex.test(report_type)) {
            return measures.Index;
        } else if (wordCountRegex.test(report_type)) {
            return measures.WC;
        } else if (reachRegex.test(report_type)) {
            return measures.Reach;
        } else {
            console.log("No report name match found");
            return;
        }
    }
    const measure = currentMeasure(report_type);
    if (isTrend) {
        return newFormatDataByTrend(
            d,
            level,
            selectedInlineGraphType,
            measure,
            selectedInlineEntity.value,
            selectedInlineDynamicFilter.value);
    }
    else if (isTonality) {
        return newFormatDataByTonality(
            d,
            level,
            selectedInlineGraphType,
            measure,
            selectedInlineEntity.value,
            selectedInlineDynamicFilter.value,
            selectedInlineSentiment.value);
    }
    else {
        return newFormatDataBySOV(
            d,
            level,
            selectedInlineGraphType,
            measure,
            selectedInlineEntity.value,
            selectedInlineDynamicFilter.value
        );
    }
};

//{datasets: {label: "", backgroundColor: "", barThcikness: "", borderColor: ""/[], borderWidth: 1, data: [], 
//fill: false, lineTension: 0}}
//{labels: [], datasets: [], hcPieChartData: [{name, y, backgroundColor}]}

const newFormatDataBySOV = (d = [], level, graphType, currentMeasure, entity, selectedTheme) => {
    const result = d;
    const graphData = result && result[result.sequence[0]].returnData.graphdata;
    const dataObj = result && result[result?.sequence[0]].returnData;
    const themes = dataObj && dataObj.themes;
    const entities = dataObj && dataObj.entities;
    const labels = entities.map((ent) => ent.entity_name);
    const datasets = [];
    const colors = getRandomUniqueColor(themes.length);
    let loopData = Object.keys(graphData);
    const legendSetLength = Math.ceil(loopData.length / 10);
    const legendSet = [];
    if (level === 'NewEntity') {
        const colors = getRandomUniqueColor(themes.length);
        themes && themes.forEach((theme, idx) => {
            const label = theme;
            const backgroundColor = colors[idx];
            const data = [];
            entities && entities.forEach(({ entity_name }) => {
                let currVal = 0;
                if (graphData[theme] &&
                    graphData[theme].hasOwnProperty(entity_name)) {
                    currVal = parseData(graphData[theme][entity_name][currentMeasure], true);
                }
                data.push(currVal);
            });
            datasets.push({ label, backgroundColor, data });
        });
        return { labels, datasets };
    } else {
        let allData = [];
        for (let i = 0; i < loopData.length; ++i) {

            entities && entities.forEach((ent) => {
                if (level === ENTITY && graphData.hasOwnProperty(loopData[i]) && graphData[loopData[i]].hasOwnProperty(ent.entity_name)) {
                    allData.push({
                        label: loopData[i],
                        data: graphData[loopData[i]][ent.entity_name],
                        entities: ent.entity_name
                    });

                } else if (graphData.hasOwnProperty(loopData[i]) && graphData[loopData[i]].hasOwnProperty(selectedTheme) && graphData[loopData[i]][selectedTheme].hasOwnProperty(ent.entity_name)) {
                    allData.push({
                        label: loopData[i],
                        data: graphData[loopData[i]][selectedTheme][ent.entity_name],
                        entities: ent.entity_name
                    });
                }

            })
        }
        allData.sort((a, b) => b.data[currentMeasure] - a.data[currentMeasure]);
        const sortedLabels = allData.map(e => e.label);
        let sortedLabelsList;
        if (level === CITY) sortedLabelsList = [...new Set(sortedLabels.map(x => x))]
        else sortedLabelsList = [...new Set(sortedLabels.map(x => x))].slice(0, 10)
        // for (let x = 1, y = 0; x <= legendSetLength; x++) {
        const set = [];
        sortedLabelsList && sortedLabelsList.forEach((val, idx) => {
            const label = val;
            const backgroundColor = colors[idx];
            const borderColor = backgroundColor;
            const borderWidth = 1;
            const fill = false;
            const data = [];
            entities && entities.forEach((ent) => {
                let currVal = 0;
                if (level === ENTITY && graphData.hasOwnProperty(val) && graphData[val].hasOwnProperty(ent.entity_name)) {
                    currVal = parseData(graphData[val][ent.entity_name][currentMeasure], true);
                } else if (graphData.hasOwnProperty(val) && graphData[val].hasOwnProperty(selectedTheme) && graphData[val][selectedTheme].hasOwnProperty(ent.entity_name)) {
                    currVal = parseData(graphData[val][selectedTheme][ent.entity_name][currentMeasure], true);
                }
                data.push(currVal);
            });
            set.push({ label, backgroundColor, borderColor, borderWidth, data, lineTension: 0, fill: "false", barThcikness: "flex" });
        });
        legendSet.push({ labels, datasets: set });
        // y = x * 10;
        // }
    }
    if (graphType === BAR_STACKED_EQUAL_HEIGHT || graphType === BAR_VERTICAL) {
        return legendSet;
    }

    const hcPieChartData = [];
    if (graphType === PIE) {
        const entityColors = getRandomUniqueColor(entities.length);
        entities && entities.forEach((ent, idx) => {
            const backgroundColor = (useDynamicEntityColors) ? (ent.color_code !== "#000000") ? ent.color_code : entityColors[idx] : entityColors[idx];
            let currVal = 0;
            if (level === ENTITY && graphData.hasOwnProperty(selectedTheme) && graphData[selectedTheme].hasOwnProperty(ent.entity_name)) {
                currVal = parseData(graphData[selectedTheme][ent.entity_name][currentMeasure], true);
            }
            hcPieChartData.push({ name: ent.entity_name, y: currVal, backgroundColor });
        });
        hcPieChartData.sort((a, b) => b.y - a.y);
        return { labels: [], datasets: [], hcPieChartData };
    }

}
//{labels: [], datasets: [], hcPieChartData: [{name, y, backgroundColor}]}
const newFormatDataByTonality = (
    d = [],
    level,
    graphType,
    currentMeasure,
    entity,
    theme,
    sentiment) => {

    if (graphType === PIE) {
        return { labels: [], datasets: [], hcPieChartData: [{}] };
    }

    const result = d;
    const graphData = result && result[result.sequence[0]].returnData.graphdata;
    const dataObj = result && result[result?.sequence[0]].returnData;
    const themes = dataObj && dataObj.themes;
    const entities = dataObj && dataObj.entities;
    const tonalities = dataObj && dataObj.tonality;
    const colors = getRandomUniqueColor(tonalities.length);
    const datasets = [];
    const labels = entities && entities.map((ent) => ent.entity_name);
    if (level === ENTITY) {
        tonalities.forEach((tone, idx) => {
            const label = tone;
            const backgroundColor = colors[idx];
            const data = [];
            entities && entities.forEach((ent) => {
                let currVal = 0;
                if (graphData[tone] && graphData[tone].hasOwnProperty(theme) && graphData[tone][theme].hasOwnProperty(ent.entity_name)) {
                    currVal = parseData(graphData[tone][theme][ent.entity_name][currentMeasure], true);
                }
                data.push(currVal);
            });
            datasets.push({ label, backgroundColor, borderColor: backgroundColor, borderWidth: 1, data, barThcikness: "flex", fill: false, lineTension: 0 });
        });
        return { labels, datasets };
    }

    const level1Keys = Object.keys(graphData);
    const level2Keys = [];
    level1Keys && level1Keys.forEach((date) => {
        const currLevel2KeyArray = Object.keys(graphData[date]);
        currLevel2KeyArray.length > 0 && currLevel2KeyArray.forEach((val, idx) => {
            if (level2Keys.indexOf(val) === -1) {
                level2Keys.push(val);
            }
        });
    });
    let allData = [];
    for (let i = 0; i < level1Keys.length; ++i) {
        level2Keys && level2Keys.forEach((level2) => {

            if (graphData[level1Keys[i]].hasOwnProperty(level2) && graphData[level1Keys[i]][level2].hasOwnProperty(theme) && graphData[level1Keys[i]][level2][theme].hasOwnProperty(entity)) {
                allData.push({
                    label: level2,
                    data: graphData[level1Keys[i]][level2][theme],
                    entities: level2
                });
            }
        })
    }

    allData.sort((a, b) => b.data[currentMeasure] - a.data[currentMeasure]);
    const sortedLabels = allData.map(e => e.label);
    let sortedLabelsList;
    if (level === CITY) sortedLabelsList = [...new Set(sortedLabels.map(x => x))]
    else sortedLabelsList = [...new Set(sortedLabels.map(x => x))].slice(0, 10)

    const level2Colors = getRandomUniqueColor(sortedLabelsList.length);
    const legendSetLength = Math.ceil(level2Keys.length / 10);
    const legendSet = [];
    // for (let x = 1, y = 0; x <= legendSetLength; x++) {
    const set = [];
    sortedLabelsList && sortedLabelsList.forEach((val, idx) => {
        const label = val;
        const backgroundColor = level2Colors[idx];
        const data = [];
        entities && entities.forEach((ent) => {
            let currVal = 0;
            if (
                graphData.hasOwnProperty(sentiment) &&
                graphData[sentiment].hasOwnProperty(val) &&
                graphData[sentiment][val].hasOwnProperty(theme) &&
                graphData[sentiment][val][theme].hasOwnProperty(ent.entity_name)
            ) {
                currVal = parseData(graphData[sentiment][val][theme][ent.entity_name][currentMeasure], true);
            }
            data.push(currVal);
        });
        set.push({ label, backgroundColor, borderColor: backgroundColor, borderWidth: 1, data, barThcikness: "flex", fill: false, lineTension: 0 });
    });
    legendSet.push({ labels, datasets: set });
    //     y = x * 10;
    // }

    return legendSet;

}

//{datasets: {label: "", backgroundColor: "", barThcikness: "", borderColor: ""/[], borderWidth: 1, data: [], fill: false, lineTension: 0}}
//{labels: [], datasets: [], hcPieChartData: [{name, y, backgroundColor}]}

const newFormatDataByTrend = (d = [], level, graphType, currentMeasure, entity, selectedTheme) => {
    const result = d;
    const graphData = result && result[result.sequence[0]].returnData.graphdata;
    const dataObj = result && result[result?.sequence[0]].returnData;
    const themes = dataObj && dataObj.themes;
    const entities = dataObj && dataObj.entities;
    const labels = entities.map((ent) => ent.entity_name);
    const datasets = [];
    const level1Keys = graphData && Object.keys(graphData).sort();
    const level2Keys = [];
    level1Keys && level1Keys.forEach((date) => {
        const currLevel2KeyArray = Object.keys(graphData[date]);
        currLevel2KeyArray.length > 0 && currLevel2KeyArray.forEach((val, idx) => {
            if (level2Keys.indexOf(val) === -1) {
                level2Keys.push(val);
            }
        });
    });

    let allData = [];
    for (let i = 0; i < level1Keys.length; ++i) {
        level2Keys && level2Keys.forEach((level2) => {
            if (level === ENTITY) {
                entities && entities.forEach((ent) => {
                    if (graphData[level1Keys[i]].hasOwnProperty(level2) && graphData[level1Keys[i]][level2].hasOwnProperty(ent.entity_name)) {
                        allData.push({
                            label: level2,
                            data: graphData[level1Keys[i]][level2][ent.entity_name],
                            entities: ent.entity_name
                        });
                    }
                })

            } else {
                if (graphData[level1Keys[i]].hasOwnProperty(level2) && graphData[level1Keys[i]][level2].hasOwnProperty(selectedTheme) && graphData[level1Keys[i]][level2][selectedTheme].hasOwnProperty(entity)) {
                    allData.push({
                        label: level2,
                        data: graphData[level1Keys[i]][level2][selectedTheme],
                        entities: level2
                    });
                }
            }

        })
    }

    allData.sort((a, b) => b.data[currentMeasure] - a.data[currentMeasure]);
    const sortedLabels = allData.map(e => e.label);
    let sortedLabelsList;
    if (level === CITY) sortedLabelsList = [...new Set(sortedLabels.map(x => x))]
    else sortedLabelsList = [...new Set(sortedLabels.map(x => x))].slice(0, 10)
    const colors = getRandomUniqueColor(sortedLabelsList.length);

    if (level === ENTITY) {
        const entityColors = getRandomUniqueColor(entities.length);
        entities && entities.forEach((ent, idx) => {
            const label = ent.entity_name;
            const backgroundColor = (useDynamicEntityColors) ? ent.color_code : entityColors[idx];
            const borderColor = backgroundColor;
            const borderWidth = 1;
            const data = [];
            level1Keys && level1Keys.forEach((date, idx) => {
                let currVal = 0;
                if (graphData[date].hasOwnProperty(selectedTheme) && graphData[date][selectedTheme].hasOwnProperty(ent.entity_name)) {
                    currVal = parseData(graphData[date][selectedTheme][ent.entity_name][currentMeasure], true);
                }
                data.push(currVal);
            });
            datasets.push({ label, backgroundColor, borderColor, borderWidth, data, lineTension: 0, fill: "false", barThcikness: "flex" });
        });
        return { labels: level1Keys, datasets };
    }
    const legendSet = [];
    const legendSetLength = Math.ceil(level2Keys.length / 10);
    // for (let x = 1, y = 0; x <= legendSetLength; x++) {
    const set = [];
    sortedLabelsList && sortedLabelsList.forEach((val, idx) => {
        const label = val;
        const backgroundColor = colors[idx];
        const borderColor = backgroundColor;
        const borderWidth = 1;
        const data = [];
        level1Keys && level1Keys.forEach((date, idx) => {
            let currVal = 0;
            if (graphData.hasOwnProperty(date) &&
                graphData[date].hasOwnProperty(val) &&
                graphData[date][val].hasOwnProperty(selectedTheme) &&
                graphData[date][val][selectedTheme].hasOwnProperty(entity)) {
                currVal = parseData(graphData[date][val][selectedTheme][entity][currentMeasure], true);
            }
            data.push(currVal);
        });
        set.push({ label, backgroundColor, borderColor, borderWidth, data, lineTension: 0, fill: "false", barThcikness: "flex" });
    });
    legendSet.push({ labels: level1Keys, datasets: set });
    //     y = x * 10;
    // }
    return legendSet;
}

const parseData = (value, float = false) => {
    let return_value = (float) ? Math.round(parseFloat(value * 100, 10)) / 100 : parseInt(value, 10);
    if (Number.isNaN(return_value)) {
        let newevalue = value.replace(/,/g, '')
        newevalue = (float) ? Math.round(parseFloat(newevalue * 100, 10)) / 100 : parseInt(newevalue, 10)
        return newevalue;
    }
    return return_value;
}
